import { useEffect, useState } from 'react';
import { stringify } from 'qs';
import api from '../api';
import { ApiProfile } from '../api/auth';

export const apiUrl = (url: string, params?: { [key: string]: any } ): string => {    
    return `${process.env.REACT_APP_API_BASE_URL}${url}?_token=${getToken()}${params ? `&${stringify(params)}` : '' }`;
}

export const ssoUrl = (url: string): string => {
    return `${process.env.REACT_APP_API_BASE_URL?.replace('commapi/', '')}auth/sso?_token=${getToken()}&r=${url}`;
    // return process.env.REACT_APP_API_BASE_URL?.replace('commapi/', '') + url.replace(/^\//, '');
}

export const getToken = (): string | null => {
    if (window.self !== window.top) {
        return null;
    }

    if (localStorage.getItem('superToken')) {
        return localStorage.getItem('superToken');
    }
    if (localStorage.getItem('accessToken')) {
        return localStorage.getItem('accessToken');
    }
    
    return null;
}

export const reloadProfile = (): void => {
    dispatchEvent(new CustomEvent('reload-profile'));
}

export const useProfile = (): ApiProfile | undefined => {
    const [ profile, setProfile ] = useState<ApiProfile>();

    useEffect(() => {
        const handle = (): void => {
            api.getProfile().then(({ data }) => {
                setProfile(data);
            });
        }
        handle();
        window.addEventListener('reload-profile', handle);
        return () => window.addEventListener('reload-profile', handle);
    }, []);

    return profile;
}
